import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import { hasPermission } from '../../../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../../../api/roles.dao';
import DefaultButton from '../../../../../global/default-button/default-button';
import { FormattedMessage } from 'react-intl';
import { Popover } from '../../../../../global/popover/popover';
import { ArtifactNotesForm } from './artifact-notes.container';

import './artifact-notes.scss';

export interface IArtifactNotesWrapperProps {
    note: string;
    artifactId: number;
    onUpdateArtifactNotes: (assetMetadataId: number, note: string) => void;
}

const ArtifactNotesWrapper = ({note, artifactId, onUpdateArtifactNotes}: IArtifactNotesWrapperProps) => {
    const [isViewOpen, setIsViewOpen] = useState<boolean>(false);
    const wrapperRef = useRef<HTMLDivElement>(null);

    const getCustomPosition = (direction: 'top' | 'left'): number | null => {
        const wrapperRect = wrapperRef.current.getBoundingClientRect();
        const scrollY = window.scrollY;
        const clientHeight = document.documentElement.clientHeight;
        const scrollX = window.scrollX;
        const clientLeft = document.documentElement.clientLeft;

        switch (direction) {
            case 'top':
                return (scrollY + wrapperRect.bottom + 300 > scrollY + clientHeight) ? -245 : null;
            case 'left':
                return (scrollX + wrapperRect.left + 300 > scrollX + clientLeft) ? -100 : null;
            default:
                return null;
        }
    };

    return (
        <td className='artifact-notes-button-wrapper hoverable'>
            <div ref={wrapperRef}>
                {note ?
                    <DefaultButton
                        text={note}
                        modifier='row'
                        className={classnames('artifact-notes-button-wrapper__note', {
                            'active': isViewOpen
                        })}
                        onClick={() => setIsViewOpen(true)}
                        withEllipsis
                    />
                    : hasPermission(Permission.EDIT_ARTIFACT) &&
                        <DefaultButton
                            text={<FormattedMessage
                                id='oe.artifact.addNotes'
                                description='Button text'
                                defaultMessage='{prefix} Add Notes'
                                values={{prefix: '+'}}
                            />}
                            className='visible-while-hovered add-notes-btn'
                            isActive={isViewOpen}
                            modifier='plus'
                            onClick={() => setIsViewOpen(true)}
                        />
                }
                <Popover
                    isOpen={isViewOpen}
                    buttonRef={wrapperRef}
                    onClose={() => setIsViewOpen(false)}
                    onClickOutside={() => setIsViewOpen(false)}
                    customWidth={382}
                    padding={0}
                    align='start'
                    position='bottom'
                    customTop={isViewOpen && getCustomPosition('top')}
                    customLeft={isViewOpen && getCustomPosition('left')}
                >
                    <ArtifactNotesForm
                        assetMetadataId={artifactId}
                        note={note}
                        closeArtifactNotesPopup={() => setIsViewOpen(false)}
                        onUpdateArtifactNotes={onUpdateArtifactNotes}
                    />
                </Popover>
            </div>
        </td>
    );
};

export default ArtifactNotesWrapper;